import { AgRendererComponent } from 'ag-grid-angular';
import { Component } from '@angular/core';

@Component({ standalone: false,
    selector: 'irb-match-cell',
    template: `<span tooltip [tooltipTitle]="params.value" [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'><span [outerHTML]="params.value | decodeHtml | highlight: params.data.match | decodeHtml"></span></span>`
})
export class MatchComponent implements AgRendererComponent {
    public params: any;

    agInit(params: any): void {
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }
}
